export function MapleMark({ className = "h-3.5 w-3.5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="1" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M12 2l1.5 3.6 3.4-1.4-.5 3.7 3.6-.3-2.2 2.9 3.1 1.7-3.4 1.2 1.4 3.4-3.6-.5.2 3.7-3.5-2.1V22h-1v-3.1l-3.5 2.1.2-3.7-3.6.5 1.4-3.4L2.5 13l3.1-1.7-2.2-2.9 3.6.3-.5-3.7 3.4 1.4L12 2z" />
      <path d="M11.5 18.9h1V22h-1z" stroke="none" />
    </svg>
  );
}

export default MapleMark;
